/* tslint:disable */
/* eslint-disable */

/**
 * 805290000 = Projekt (Projekt)
 * 
 * 805290001 = Projektidee (Projektidee)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceXfoundportalobjekt {
 Projekt = 805290000,
 Projektidee = 805290001
}

marker([
    "Enum.GlobalEnumsAceXfoundportalobjekt.Projekt",
    "Enum.GlobalEnumsAceXfoundportalobjekt.Projektidee"
]);

export namespace GlobalEnumsAceXfoundportalobjekt
{
    class DataSets
    {
        static GlobalEnumsAceXfoundportalobjektDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Projekt", 805290000, "Projekt"),
            new EnumValue("Projektidee", 805290001, "Projektidee"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceXfoundportalobjektDataSet;
    }
}
